import {FIELD_TYPE} from "types/enums";

const {RADIO_BUTTON, INPUT, CHECKBOX, TEXT_AREA} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 12, lg: 12, xl: 12};
const wrapperCol = {xs: 16, md: 16, lg: 16};
const labelCol = {xs: 8, md: 8, lg: 8};

const FieldsAppendAgesRight: any[] = [
  {
    name: ["rightJsonValue", "APPENDAGES", "Option"],
    type: CHECKBOX,
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    // labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 24, md: 24, lg: 24},
    label: "",
    checkbox: [
      {
        label: "Mi mắt",
        value: "Mi mắt",
        span: 6,
      },
      {
        label: "Lông mi",
        value: "Lông mi",
        span: 6,
      },
      {
        label: "Túi lệ",
        value: "Túi lệ",
        span: 6,
      },
      {
        label: "Thăm dò lệ đạo",
        value: "Thăm dò lệ đạo",
        span: 6,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "APPENDAGES", "show"],
    hide: true,
  },
];
const fieldsEyelidsRight: any[] = [
  {
    label: "Chắp",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Chắp"],
    value: false,
  },
  {
    label: "Sụp mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Sụp mi"],
    value: false,
  },
  {
    label: "Sưng nề",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Sưng nề"],
    value: false,
  },
  {
    label: "Quặm",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Quặm"],
    value: false,
  },
  {
    label: "Lật mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Lật mi"],
    value: false,
  },
  {
    label: "Khối u",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Khối u"],
    value: false,
  },
  {
    label: "Viêm bờ mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Mi mắt", "Viêm bờ mi"],
    value: false,
  },
];
const fieldsEyelashesRight: any[] = [
  {
    label: "Lông xiêu",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Lông mi", "Lông xiêu"],
    value: false,
  },
  {
    label: "Nhiều hàng lông mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Lông mi", "Nhiều hàng lông mi"],
    value: false,
  },
];
const fieldsLacrimalRight: any[] = [
  {
    label: "Sưng nề",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Túi lệ", "Sưng nề"],
    value: false,
  },
  {
    label: "Ấn túi lệ",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["rightJsonValue", "APPENDAGES", "Túi lệ", "Ấn túi lệ"],
    value: false,
  },
];
const fieldsSyryingRight: any[] = [
  {
    label: "Thăm dò lệ đạo",
    type: RADIO_BUTTON,
    css: css,
    name: ["rightJsonValue", "APPENDAGES", "Thăm dò lệ đạo"],
    radioButtons: [
      {label: "Thông tốt", value: "Thông tốt"},
      {label: "Tắc", value: "Tắc"},
    ],
    value: "Tắc",
  },
];
const FieldsAppendAgesLeft: any[] = [
  {
    name: ["leftJsonValue", "APPENDAGES", "Option"],
    type: CHECKBOX,
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},

    wrapperCol: {xs: 24, md: 24, lg: 24},
    label: "",
    checkbox: [
      {
        label: "Mi mắt",
        value: "Mi mắt",
        span: 6,
      },
      {
        label: "Lông mi",
        value: "Lông mi",
        span: 6,
      },
      {
        label: "Túi lệ",
        value: "Túi lệ",
        span: 6,
      },
      {
        label: "Thăm dò lệ đạo",
        value: "Thăm dò lệ đạo",
        span: 6,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "APPENDAGES", "show"],
    hide: true,
  },
];
const fieldsEyelidsLeft: any[] = [
  {
    label: "Chắp",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Chắp"],
    value: false,
  },
  {
    label: "Sụp mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Sụp mi"],
    value: false,
  },
  {
    label: "Sưng nề",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Sưng nề"],
    value: false,
  },
  {
    label: "Quặm",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Quặm"],
    value: false,
  },
  {
    label: "Lật mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Lật mi"],
    value: false,
  },
  {
    label: "Khối u",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Khối u"],
    value: false,
  },
  {
    label: "Viêm bờ mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Mi mắt", "Viêm bờ mi"],
    value: false,
  },
];
const fieldsEyelashesLeft: any[] = [
  {
    label: "Lông xiêu",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Lông mi", "Lông xiêu"],
    value: false,
  },
  {
    label: "Nhiều hàng lông mi",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Lông mi", "Nhiều hàng lông mi"],
    value: false,
  },
];
const fieldsLacrimalLeft: any[] = [
  {
    label: "Sưng nề",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Túi lệ", "Sưng nề"],
    value: false,
  },
  {
    label: "Ấn túi lệ",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Túi lệ", "Ấn túi lệ"],
    value: false,
  },
];
const fieldsSyryingLeft: any[] = [
  {
    label: "Thăm dò lệ đạo",
    type: RADIO_BUTTON,
    css: css,
    // labelCol: labelCol,
    // wrapperCol: wrapperCol,
    name: ["leftJsonValue", "APPENDAGES", "Thăm dò lệ đạo"],
    radioButtons: [
      {label: "Thông tốt", value: "Thông tốt"},
      {label: "Tắc", value: "Tắc"},
    ],
    value: "Tắc",
  },
];
const fieldsCommentLeft = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "APPENDAGES", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
];
const fieldsCommentRight = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "APPENDAGES", "Ghi chú"],
    css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
    // suffix: (
    //   <Icon
    //     rev={0}
    //     style={{fontSize: "24px"}}
    //     component={Icons.file as React.ForwardRefExoticComponent<any>}
    //   />
    // ),
  },
];
export {
  FieldsAppendAgesRight,
  fieldsEyelidsRight,
  fieldsEyelashesRight,
  fieldsLacrimalRight,
  fieldsSyryingRight,
  FieldsAppendAgesLeft,
  fieldsEyelidsLeft,
  fieldsEyelashesLeft,
  fieldsLacrimalLeft,
  fieldsSyryingLeft,
  fieldsCommentLeft,
  fieldsCommentRight,
};
